import { Component, ErrorHandler, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { UserService } from '../../../../shared/user.service';
declare const $: any;

@Component({
  selector: 'app-patientstatusform',
  templateUrl: './patientstatusform.component.html',
  styleUrls: ['./patientstatusform.component.css']
})
export class PatientstatusformComponent implements OnInit {
  title2 = "Patient History";
 
  Patient: any = [];
  PatientData: any;
  ClinicalDiscipline: any = [];
  ClinicalDisciplineData: any;
  data: any;
  EP: any = {};
  P: any = {};
  C: any = {};
  PR_Age: any;
  PR_Id: any;
  mode:any;
  SpecializationData: any;
  HospitalData: any;
  Hospital: any =[];
  docorlist: any =[];
  Specializationlist: any =[];
  Prescription: any = [];
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,) { }


  ngOnInit() {
    this.GetPatientDropDown();
    this.GetClinicalDisciplineDown();
    this.GetClinicalDisciplineDropDown();
    this.GetConsultancySpecializationDropDown();
    this.GetConsultancyHospitalDropDown();
  }

  GetPatientDropDown() {
    this.PatientData = this.userService.GetPatientDropDown();
    this.PatientData.subscribe(
      (Resp: any) => {
        this.Patient = Resp.Result;
      }
    )
  }

 
  GetClinicalDisciplineDropDown() {
    this.ClinicalDisciplineData = this.userService.GetClinicalDisciplineDropDown();
    this.ClinicalDisciplineData.subscribe(
      (Resp: any) => {
        this.ClinicalDiscipline = Resp.Result;
      }
    )
  }

  GetConsultancySpecializationDropDown() {
    this.SpecializationData = this.userService.GetConsultancySpecializationDropDown();
    this.SpecializationData.subscribe(
      (Resp: any) => {
        this.Specializationlist = Resp.Result;
      }
    )
  }

  GetConsultancyHospitalDropDown() {
    this.HospitalData = this.userService.GetConsultancyHospitalDropDown();
    this.HospitalData.subscribe(
      (Resp: any) => {
        this.Hospital = Resp.Result;
      }
    )

    this.HospitalData = this.userService.GetDoctorDropDownlist();
    this.HospitalData.subscribe(
      (Resp: any) => {
        this.docorlist = Resp.Result;
      }
    )
  }
  GetClinicalDisciplineDown() {
    this.ClinicalDisciplineData = this.userService.GetClinicalDisciplineDown();
    this.ClinicalDisciplineData.subscribe(
      (Resp: any) => {
        this.ClinicalDiscipline = Resp.Result;
      }
    )
  }

  GetPatientGistory(PR_Id) {
    debugger;
    // alert(PR_Id);

    this.data = this.userService.GetHealthRecords(PR_Id);
    this.data.subscribe(
      (response: any) => {
        this.P = response;
        // this.P.Visit =response.VI_Id;
        this.Prescription = response.PrescriptionList;      
        if (this.P.PR_DOB != null)
          this.P.PR_DOB = ((this.P.PR_DOB).split('T'))[0];
          if (this.P.VI_ConsultedDate != null)
          this.P.VI_ConsultedDate = ((this.P.VI_ConsultedDate).split('T'))[0];
          
          
          this.CalculateAge(response.PR_DOB);
      }, (error) => {
      });


  }

  CalculateAge(dateOfBirth) {
    this.data = this.userService.calculateAge(dateOfBirth);
    this.data.subscribe(
      (response: any) => {
          this.PR_Age = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  CreateExistingPatient(ExistingPatient) {
    debugger;
    // ExistingPatient.PR_Id = PR_Id;
    // this.PR_Id = ExistingPatient.PR_Id;
    this.data = this.userService.CreateExistingPatient(ExistingPatient);
    this.data.subscribe(
      (response) => {
        swal('Success!', 'Existing Patient Details Added Successfully .', 'success');
        this.router.navigate(['/home/existingpatient']);
      }, (error) => {
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }


 
}



// WEBPACK FOOTER //
// ./src/app/Pages/tasks/patientstatus/patientstatusform/patientstatusform.component.ts